import collection from './../utils/collection';
import './../utils/promise';
import ResourceLocator from './resourceLocator';

export default class Product {
    constructor(item) {
        this.item = item;
    }

    create(item) {
        return new Product(item);
    }

    getProduct(productId) {
        let keys = this.getUrlOptions(),
            product;
        delete keys.action;
        keys.prodlevid = productId;

        let promise = new Promise((resolve, reject) => {
            $.ajax({
                url:'?action=product/data',
                cache: false,
                data:keys
            }).then( function (response) {
                product = collection([response.product], new Product)[0];
                product.relatedProducts = response.relatedProducts;
                product.breadcrumbs = response.breadcrumbs;
                resolve(product);
            }).catch(function () {
                reject();
            })
        });

        return promise;
    }

    getUrlOptions() {
        let keys = {};

        location.search.substr(1).split('&').forEach(function(item) {
            item = item.split('=');
            keys[item[0]] = item[1];
        });
        return keys;
    }

    productUrlWithOptions(resetGoogleTag) {
        return `${this.url}${this.urlOptions(resetGoogleTag)}`;
    }

    urlOptions(resetGoogleTag) {
        let resourceLocator = new ResourceLocator();

        return resourceLocator.urlOptions(resetGoogleTag);
    }

    get id() {return this.item.prodlevId || this.item.prodlevid|| this.item.id ; }
    get imageUrl() {
        let imageUrl = this.item.imageUrl;

        if(!imageUrl && this.item.multiImages && this.item.multiImages.length){
            imageUrl = this.item.multiImages[0].medium.url;
        }

        return imageUrl;
    }
    get price() {
        let price = this.item.price ? this.item.price : {};

        price.former = price.former ? price.former : (price.sprice ? price.sprice : price.spriceInclTax);
        price.current = price.current ? price.current : (price.priceInclTax ? price.priceInclTax : this.item.eurprice);

        return price
    }
    get promoSection() {return this.item.promoSection; }
    get score() {
        let score = this.item.score;

        if(!score && this.item.reviewRating){
            score = this.item.reviewRating.voted;
        }

        return score;
    }
    get stars() {
        let stars = this.item.stars;

        if(!stars && this.item.reviewRating){
            stars = this.item.reviewRating.score;
        }

        return stars;
    }
    get text() {
        return this.item.text ? this.item.text : this.item.name;
    }
    get title() {
        return this.item.title ? this.item.title : this.item.vendor;
    }
    get fullName() {
        let vendorName = this.item.title ? this.item.title : this.item.vendor;
        let productName = this.item.text ? this.item.text : this.item.name;

        return `${vendorName} ${productName}`;
    }
    get vendor() {return this.item.vendor; }
    get vendorUrl() {return this.item.vendorUrl;}
    get vendorPath() { return this.item.vendorPath; }
    get vendorLogo() {return this.item.vendor_logo; }
    get name() {return this.item.name; }
    get description() {return this.item.description; }
    get isConverted() {return this.item.isConverted; }
    get specification() {return this.item.specification; }
    get specificationName() {return this.item.specificationName; }
    get specificationValue() {return this.item.specificationValue; }
    get variations() { return this.item.variations; }
    get multiImages() {return this.item.multiImages; }
    get stock() {return this.item.stock}
    get showStock() {return this.item.showStock; }
    get stockColor() {return this.item.stockColor; }
    get url() {return this.item.url; }
    get specialSale() { return this.item.specialSale; }
    get videos() { return this.item.videos; }
    get sizetable() { return this.item.sizetable; }
    get banners() {
        return this.item.banners ? this.item.banners : [];
    };
    get rating() {
        return this.item.rating ? this.item.rating : {};
    };
    get reviewRating() {
        return this.item.reviewRating ? this.item.reviewRating : {};
    };
    get bundles() {
        let bundles = this.item.bundles ? this.item.bundles : [];
        let currentBundle;

        bundles = bundles.map(function (bundleCard) {

            if(!bundleCard.idBundle){
                currentBundle = collection(bundleCard.bundle, new Product);
                currentBundle.idBundle = bundleCard.id;
                currentBundle.canShowSellingPriceOnly = bundleCard.canShowSellingPriceOnly;
            }else{
                currentBundle = bundleCard;
            }


            return currentBundle
        });

        return window.bundles;
    };
    set bundles(bundles) {this.item.bundles = bundles};
    set videos(videos) {this.item.videos = videos};
    get slides() {
        if (this.item.videos && !this.item.slided) {
            let index = this.item.multiImages.length >= 2 ? 2 : 1;
            this.item.videos = this.item.videos.map(function (v) {
                return {isVideo: true, video: v}
            });
            let tempImages = this.item.multiImages;
            tempImages = tempImages.filter(img => img.isVideo)
            tempImages = tempImages.map(img => img.video)
            for (let i = 0; i < this.item.videos.length; i++) {
                if (tempImages.indexOf(this.item.videos[i].video.video) === -1) {
                    this.item.multiImages.splice(index + i, 0, this.item.videos[i])
                }
            }
            this.item.slided = true
        }
        return this.item.multiImages
    }
    get salesCount () {return this.item.salesCount;}
    get hasSalesCount () {return this.item.hasSalesCount;}
    get isBundle() {return this.item.isBundle;}
    get bundleImages() {return this.item.bundleImages;}
    get bundleStock() {return this.item.bundleStock;}
    get isWishlist() {return this.item.isWishlist;}
    get quantity() {return this.item.quantity;}
    get isStock() {return this.item.isStock;}
    get categoryUrl() {return this.item.categoryUrl;}
    get soldOut() {return this.item.soldOut;}
    get descOms() {return this.item.descOms;}
    get seoTags() {return this.item.seoTags;}
    get sku() {return this.item.sku;}
    get googleStock() {return this.item.googleStock;}
    get metaTags() {return this.item.metaTags;}
    get isSentStatictics() {return Boolean(this.item.isSentStatictics);}
    set isSentStatictics(statictics) {this.item.isSentStatictics = statictics}
    get commonId() {return this.item.commonId;}
    set reviewPageUrl(reviewPageUrl) {this.item.reviewPageUrl = reviewPageUrl}
    get reviewPageUrl() {return this.item.reviewPageUrl}
    get reviewMetaTags() {return this.item.reviewMetaTags}
    get promotionText() {return this.item.promotionText}
    get commonUrl() {return this.item.commonUrl;}
    get openOfficeTime() {return this.item.openOfficeTime;}
    get thumbImage() {
        let thumbImage;

        if (this.item.multiImages.length) {
            thumbImage = this.item.multiImages[0].thumb.url || this.item.multiImages[0].medium.url || this.item.imageUrl;
        }

        return thumbImage;
    }
    get defaultProductId() {
        return this.item.defaultProductId;
    }
    get hoverImageUrl() {
        return this.item.hoverImageUrl;
    }
    get upperCaseFullName() {
        return `${this.title} ${this.text}`;
    }
    get highlights() {
        return this.item.highlights;
    }
    get features() {
        return this.item.features;
    }
    get sizeGuide() {
        return this.item.sizeGuide;
    }
    get specifications() {
        return this.item.specifications;
    }
    get component() {
        return this.item.component;
    }
    get quote() {
        return this.item.quote;
    }
    get guarantee() {
        return this.item.guarantee;
    }
}
